import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'formik'
import DateInput from '../DateInput'
import * as S from '../DateInput/styled'

const dateBoundaries = date => {
    return {
        start: new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0),
        end: new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59),
    }
}

const DateRange = ({ fromName, toName, fromLabel = '', toLabel = '', required = false }) => {
    return (
        <S.DatePickerInput className="form-group">
            <S.DatePickerContainer className="form-row">
                <Field name={fromName}>
                    {({ form }) => (
                        <>
                            <div className="col-12 col-md-6">
                                <DateInput
                                    name={fromName}
                                    label={fromLabel}
                                    selectsStart
                                    startDate={form.values[fromName]}
                                    endDate={form.values[toName]}
                                    maxDate={form.values[toName]}
                                    setTime={date => dateBoundaries(date).start}
                                    rawDate={true}
                                    required={required}
                                />
                            </div>
                            <div className="col-12 col-md-6">
                                <DateInput
                                    name={toName}
                                    label={toLabel}
                                    selectsEnd
                                    startDate={form.values[fromName]}
                                    endDate={form.values[toName]}
                                    minDate={form.values[fromName]}
                                    setTime={date => dateBoundaries(date).end}
                                    rawDate={true}
                                    required={required}
                                />
                            </div>
                        </>
                    )}
                </Field>
            </S.DatePickerContainer>
        </S.DatePickerInput>
    )
}

DateRange.displayName = 'DateRange'

DateRange.propTypes = {
    fromName: PropTypes.string.isRequired,
    toName: PropTypes.string.isRequired,
    fromLabel: PropTypes.string,
    toLabel: PropTypes.string,
    help: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    placeholder: PropTypes.string,
    className: PropTypes.string,
    show: PropTypes.string,
    prefix: PropTypes.string,
}

export default DateRange
